import formatDecimal from '@/filters/format-decimal'

export default {
  name: 'oz-title',

  props: {
    pagination: { type: Object },
    primaryHeading: { type: String, required: true },
    align: { type: String },
  },

  computed: {
    title () {
      const {
        primaryHeading,
        pagination: { totalCount } = {},
      } = this

      return [totalCount ? formatDecimal({ value: totalCount }) : null, primaryHeading]
        .filter((item) => !!item).join(' ')
    },

    headingProps () {
      return {
        class: 'results__title',
        props: {
          tag: 'h1',
          weight: 'bold',
          align: this.align,
          noMargin: true,
        },
      }
    },
  },

  render () {
    const { headingProps, title } = this

    return (<l-heading {...headingProps}>{title}</l-heading>)
  },
}
